module.exports = __webpack_public_path__ + "media/images/application/template/icon--download-073a994a4cc7c5582ff59e20232c514e.svg";